import { ApiClient } from '@/shared/api-client';
import { IMetric } from '@/shared/api-client/models';
import MetricsComponent from '@/shared/components/metrics-component/metrics-component.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        MetricsComponent
    }
})
export default class MetricsModalComponent extends Vue {

    @Prop() public organizationalUnitPaths!: string[];

    @Prop() public translations!: { [key: string]: string; };

    @Prop({ default: 'sv-SE' }) public language!: string;

    private apiClient: ApiClient = new ApiClient();

    public aggregationCollections: IMetric[][] = new Array<IMetric[]>();

    constructor() {
        super();
    }

    public async openModal(): Promise<void> {

        $(`#MetricsModal`).modal('show');
    }
}
